const aes_key = process.env.VUE_APP_AES_SECRET_KEY || "";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { AES, enc } from "crypto-js";
export function decrypt_password(password: string): string {
  return AES.decrypt(password, aes_key).toString(enc.Utf8);
}
